import Keycloak, { KeycloakConfig } from 'keycloak-js'

export const initKeycloak = async (
  keycloakConfig: KeycloakConfig,
  publicUrls: string[]
): Promise<Keycloak> => {
  const keycloak = new Keycloak(keycloakConfig)
  const isPublicRoute = publicUrls.some(publicUrl =>
    window.location.pathname.startsWith(publicUrl)
  )
  await keycloak.init({
    checkLoginIframe: false,
    onLoad: isPublicRoute ? 'check-sso' : 'login-required',
    pkceMethod: 'S256'
  })

  return keycloak
}
